import React from "react";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { Form, Button } from "antd";
import { INPUT_TYPES } from "constants/input-types";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import cx from "classnames";
import "styles/form.css";

const FormItem = Form.Item;
const addUtrFields = new OrderedMap({
    date: {
        type: INPUT_TYPES.DATE,
        label: "Transaction Date",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    amount: {
        type: INPUT_TYPES.FLOAT,
        label: "Processing Fee Amount",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    merchant_id: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Mannual",
        label: "Merchant ID",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    transaction_detail: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Mannual",
        label: "Transaction Detail",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    order_id: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Mannual",
        label: "Order ID",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    }
});

class UTRForm extends React.Component {

    componentDidUpdate() {
        let amount = this.props.form.getFieldValue("amount");
        if(this.props.processing_fee_amount && !amount) {
            this.props.form.setFieldsValue({
                amount: this.props.processing_fee_amount
            });
        }
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    save = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.props.form.validateFields((err, values) => {
            if(!err) {
                this.props.update({...values, date: values.date && values.date.format("YYYY-MM-DD")});
            }

        });
    }

    render() {
        return (
            <Form onSubmit={this.save}>
                <div className={"form-row"}>
                    {addUtrFields
                        .map((field, fieldName) => {
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )();
                        })
                        .toList()
                        .toJS()}
                </div>
                <div className="form-row d-flex justify-content-space-between">
                    <FormItem className={cx("m-0")}>
                        <Button
                            type="primary"
                            icon={"plus"}
                            onClick={this.save}
                        >
                            Save
                        </Button>
                    </FormItem>
                </div>
            </Form>
        );
    }
}

UTRForm.propTypes = {
    form: PropTypes.object,
    update: PropTypes.func,
    processing_fee_amount: PropTypes.number
};

export default Form.create({})(UTRForm);
